import React from "react";
import CycleOperations from "../ciclosAccespark";
export default function EzytecCiclo() {
  return <CycleOperations system="ezytec" />;
}
